import { Select } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { getSaleStatus } from 'src/core/helpers'
import styles from '../../SaleListHeader.module.scss'
import { FilterSaleOption, Sale } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  setMySalesFilterText,
  oldSaleListSelector,
  setMySalesFiltered
} from 'src/features'
const { Option } = Select

const filterOptions = {
  ALL: 'ALL',
  AWAITING_DOCS: 'AWAITING_DOCS',
  IN_REVIEW: 'IN_REVIEW',
  VALIDATED: 'VALIDATED',
}

const FilterOrderByStatus = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const oldSaleList = useAppSelector(oldSaleListSelector)
  const [selectedFilter, setSelectedFilter] = useState(filterOptions.ALL)

  const handleChange = (value: FilterSaleOption) => {
    setSelectedFilter(value)
    const newSaleList: Sale[] = getNewSalesFiltered(value)
    dispatch(setMySalesFiltered(newSaleList))
  }

  const getNewSalesFiltered = (option: FilterSaleOption): Sale[] => {
    dispatch(setMySalesFilterText(null))
    if (option === 'ALL') return oldSaleList
    return oldSaleList.filter((sale: Sale) => getSaleStatus(sale) === option)
  }

  return (
    <Select
      value={selectedFilter}
      onChange={handleChange}
      className={`${styles['btnAll']} margin-with`}
    >
      <Option value={filterOptions.ALL}>{t('Messages.All')}</Option>
      <Option value={filterOptions.AWAITING_DOCS}>{t('Transactions.AwaitingDocs')}</Option>
      <Option value={filterOptions.IN_REVIEW}>{t('Transactions.InReview')}</Option>
      <Option value={filterOptions.VALIDATED}>{t('Transactions.Validated')}</Option>
    </ Select>
  )
}

export default FilterOrderByStatus
